import React from "react";

import './ProgramProgress.scss';

const ProgramProgress = props => {
	const {value} = props;

	if(value == null) {
		return (
			<div className="program-progress-container">
				<div className="program-progress-suggested">SUGGESTED</div>
			</div>
		)
	}

	if(value === 100) {
		return (
			<div className="program-progress-container">
				<div className="program-progress-completed">COMPLETED</div>
			</div>
		)
	}

	let color = '#F37249';

	if(value > 30) {
		color = '#FF9E67';
	}
	if(value > 50) {
		color = '#FFC267';
	}
	if(value > 70) {
		color = '#40A0C1';
	}

	return (
		<div className="program-progress-container">
			<div className="program-progress-label">{value}%</div>
			<div className="program-progress-bar">
				<div className="program-progress-bar-filled" style={{backgroundColor: color, width: `${value}%`}} />
			</div>
		</div>
	)
};

export default ProgramProgress;